import React, { useState, createElement, useEffect, useRef } from "react";
import "./AnnotationSection.css"
// NORTON DESIGN SYSTEM
import { Button } from '@wwnds/react';
// COMPONENTS
import Annotation from "../Annotation/Annotation";
import AnnotationHeading from "../AnnotationHeading/AnnotationHeading";
import AnnotationDivider from "../AnnotationDivider/AnnotationDivider";
// ICONS
import getStartedPNG from '../../assets/2e/getting-started.png';
import contentPNG from '../../assets/2e/content.png';
import deliveryPNG from '../../assets/2e/delivery.png';
import engagingPNG from '../../assets/2e/engaging-your-audience.png';
import fundamentalsPNG from '../../assets/2e/fundamentals.png';
// import resourcesPNG from '../../assets/2e/resources.png';
import speakingPNG from '../../assets/2e/speaking-to-inform.png';
import speakingOccasionsPNG from '../../assets/2e/speaking-occasions.png';
import speakingPersuadePNG from '../../assets/2e/speaking-to-persuade.png';

const AnnotationSection = ({
  Data,
  timelineIndex,
  formatTime,
  formatSectionHeaderStr,
  version,
  updateTime }) => {

  const [activeTab, setActiveTab] = useState("current")

  // handles click on tab button
  const tabClick = (value) => {
    setActiveTab(value)
  }

  const [currentAnnotationRef, setCurrentAnnotationRef] = useState()

  // AUTOSCROLL
  const annotationPaneRef = useRef(null)
  useEffect(() => {
    if (currentAnnotationRef && annotationPaneRef) {
      annotationPaneRef.current.scrollTo(
        {
          top: currentAnnotationRef.offsetTop - annotationPaneRef.current.offsetTop,
          behavior: 'smooth',
        }
      )
    }
  }, [currentAnnotationRef, annotationPaneRef])

  const getTimelineIcon = (color) => {
    // console.log(color)
    if (color === "getting-started") { return getStartedPNG }
    if (color === "content") { return contentPNG }
    if (color === "delivery") { return deliveryPNG }
    if (color === "engaging-your-audience") { return engagingPNG }
    if (color === "fundamentals") { return fundamentalsPNG }
    // if (color === "resources") { return resourcesPNG }
    if (color === "speaking-to-inform") { return speakingPNG }
    if (color === "speaking-occasions") { return speakingOccasionsPNG }
    if (color === "speaking-to-persuade") { return speakingPersuadePNG }

  }

  return (
    <section className="annotation-section">
      <div className="tab-btn-container-wrapper">
        <div className="tab-btn-container">
          <Button className={activeTab === "current" ? "active-tab" : "tab-btn"} onClick={() => tabClick("current")}
            textClass="tab-btn-txt"
          >Show Current</Button>
          <Button className={activeTab === "all" ? "active-tab" : "tab-btn"} onClick={() => tabClick("all")}
            textClass="tab-btn-txt"
          >Show All</Button>
        </div>
      </div>
      <div className={version === "new" ? "annotation-pane-frame" : "annotation-pane"} ref={annotationPaneRef}>
        <div className={activeTab === "all" ? "show-annotation" : "hide-annotation"}>
          {Data.enableMod[0].interact.timelines.map((timeline, index) => (
            <div key={index}>
              <AnnotationDivider
                timeline={timeline}
                formatSectionHeaderStr={formatSectionHeaderStr}
                formatTime={formatTime}
              />
              <div
                className="annotation-div-container"
                ref={index === timelineIndex ? setCurrentAnnotationRef : null}>
                <div className={index === timelineIndex ? "highlight-annotation" : "hide-highlight-annotation"}>
                  {timeline.type ?
                    <img src={getTimelineIcon(timeline.type)} alt={timeline.timeline} />
                    :
                    <span className="bullet">&#11044;</span>
                  }
                </div>
                <div className="annotation-div">
                  <AnnotationHeading
                    timeline={timeline}
                    formatTime={formatTime}
                    formatSectionHeaderStr={formatSectionHeaderStr}
                    updateTime={updateTime}
                    timelineIndex={timelineIndex}
                    Data={Data}
                  />
                  <Annotation
                    timeline={timeline}
                    createElement={createElement}
                    annotationPaneRef={annotationPaneRef}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={activeTab === "current" ? "show-annotation" : "hide-annotation"}>
          <div className="annotation-div-container">
            <div className="highlight-annotation">
              {Data.enableMod[0].interact.timelines[timelineIndex].type ?
                <img src={getTimelineIcon(Data.enableMod[0].interact.timelines[timelineIndex].type)} alt={Data.enableMod[0].interact.timelines[timelineIndex].timeline} />
                :
                <span className="bullet">&#11044;</span>
              }
            </div>
            <div id="current-annotation" className="annotation-div" aria-live="polite" aria-atomic>
              <AnnotationHeading
                timeline={Data.enableMod[0].interact.timelines[timelineIndex]}
                formatTime={formatTime}
                formatSectionHeaderStr={formatSectionHeaderStr}
                updateTime={updateTime}
                timelineIndex={timelineIndex}
                Data={Data}
              />
              <Annotation
                timeline={Data.enableMod[0].interact.timelines[timelineIndex]}
                createElement={createElement}
                timelineIndex={timelineIndex}
                Data={Data}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AnnotationSection;